import React from 'react';
import './AwarenessModule.scss';
import Button from '../../../../components/Shared/Button/Button';
import trpLogo from '../../../../assets/images/trp-logo.svg';

const AwarenessModule = ({ handleAwarenessModule }) => (
  <div className="awareness-module">
    <div className="awareness-module-trp-modal-head">
      <img alt="trp-logo" src={trpLogo} />
    </div>
    <div className="awareness-module-am-body-content">
      <div className="awareness-module-am-body-left">
        <div className="awareness-module-am-heading">
          You spoke, we listened
        </div>
        <div className="awareness-module-am-subheading">
          <span className="awareness-module-callout-text">
            It's a whole new sell experience &mdash;
          </span>
          <span>fueled by</span>
          <p>feedback from clients just like you &mdash; with</p>
          <p>
            a more
            <span className="awareness-module-callout-text space">
              intuitive design, upgraded functionality,
            </span>
          </p>
          <p>
            <span className="awareness-module-callout-text">
              and even more features
            </span>
            on the way.
          </p>
        </div>
        <div className="awareness-module-am-tagline">
          Welcome to our NEW sell experience!
        </div>
      </div>
      <div className="awareness-module-am-body-right">
        <svg
          className="awareness-module-welcome-image"
          xmlns="https://www.w3.org/2000/svg"
          width="234"
          height="183"
          viewBox="0 0 234 183"
        >
          <g fill="none" fillRule="evenodd">
            <path
              fill="#E6F9FB"
              d="M111 181c-24.302 0-44-2.014-44-4.5s19.698-4.5 44-4.5c24.3 0 44 2.014 44 4.5s-19.7 4.5-44 4.5zM122.5 0C69.758 0 27 42.791 27 95.575A95.229 95.229 0 0 0 35.51 135H209.49A95.229 95.229 0 0 0 218 95.575C218 42.791 175.242 0 122.5 0z"
            />
            <path
              stroke="#054C70"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M28 136h186M17 136h6M219 136h6"
            />
            <g strokeLinejoin="round">
              <path
                fill="#FFF"
                stroke="#054C70"
                d="M1.765 69.569c-1.149-1.99-.44-4.551 1.584-5.72l40.304-23.27c2.023-1.167 4.594-.5 5.743 1.49l16.122 27.924c1.15 1.99.442 4.55-1.582 5.718l-12.824 7.405 2.103 6.659-11.264-1.37-18.32 10.576c-2.023 1.168-4.595.502-5.744-1.488L1.765 69.57z"
              />
              <path
                stroke="#05C3DE"
                strokeLinecap="round"
                d="M15.633 72.778l19.918-11.5M19.349 79.214l27.713-16M23.065 85.651l27.713-16"
              />
            </g>
            <g strokeLinejoin="round">
              <path
                fill="#FFF"
                stroke="#054C70"
                d="M232.235 69.569c1.149-1.99.44-4.551-1.584-5.72l-40.304-23.27c-2.023-1.167-4.594-.5-5.743 1.49l-16.122 27.924c-1.15 1.99-.442 4.55 1.582 5.718l12.824 7.405-2.103 6.659 11.264-1.37 18.32 10.576c2.023 1.168 4.595.502 5.744-1.488l16.122-27.924z"
              />
              <path
                stroke="#05C3DE"
                strokeLinecap="round"
                d="M188.759 55.683l19.918 11.5M185.042 62.12l27.713 16M181.326 68.557l27.713 16"
              />
            </g>
            <path
              fill="#FFF"
              stroke="#054C70"
              strokeLinejoin="round"
              d="M144 9.095C144 6.833 141.656 5 138.762 5H94.238C91.346 5 89 6.833 89 9.095v31.742c0 2.26 2.344 4.095 5.238 4.095h18.042l5.679 7.183 3.716-7.183h17.087c2.894 0 5.238-1.834 5.238-4.095V9.095z"
            />
            <g stroke="#05C3DE" strokeLinecap="round" strokeLinejoin="round">
              <path d="M130.773 16.53h-27.314c-.402 0-.753.16-1.045.392l12.95 7.772a3.404 3.404 0 0 0 3.503 0l12.953-7.772c-.292-.234-.645-.393-1.047-.393z" />
              <path d="M130.854 34.96H103.38c-.895 0-1.621-.727-1.621-1.622V18.15c0-.894.726-1.62 1.62-1.62h27.476c.895 0 1.62.726 1.62 1.62v15.19c0 .894-.725 1.62-1.62 1.62z" />
            </g>
            <g fillRule="nonzero" transform="translate(77 65)">
              <rect
                width="79"
                height="98.2"
                x=".5"
                y="12.233"
                fill="#C5F5FA"
                stroke="#054C70"
                rx="4"
              />
              <rect
                width="64.067"
                height="80.067"
                x="7.967"
                y="21.833"
                fill="#FFF"
                stroke="#054C70"
                rx="4"
              />
              <rect
                width="39.533"
                height="18.2"
                x="20.767"
                y="7.967"
                fill="#FFF"
                stroke="#054C70"
                rx="2"
              />
              <circle
                cx="40.533"
                cy="6.4"
                r="6.4"
                fill="#FFF"
                stroke="#054C70"
              />
              <rect width="40" height="2" x="16" y="40" fill="#054C70" rx="1" />
              <rect width="40" height="2" x="16" y="50" fill="#054C70" rx="1" />
              <rect width="28" height="2" x="16" y="60" fill="#054C70" rx="1" />
              <rect width="28" height="2" x="16" y="69" fill="#054C70" rx="1" />
              <rect width="21" height="2" x="29" y="19" fill="#054C70" rx="1" />
            </g>
            <path
              fill="#FFF"
              stroke="#054C70"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M187.711 155.054c0 14.778-11.771 26.759-26.285 26.759s-26.282-11.981-26.282-26.759c0-14.78 11.768-26.762 26.282-26.762s26.285 11.981 26.285 26.762z"
            />
            <g transform="translate(146 139)">
              <circle cx="16" cy="16" r="16" fill="#FFF" fillRule="nonzero" />
              <path
                fill="#05C3DE"
                d="M3.8 15.493L1 18.418l9 9.403L30 6.925 27.2 4 10 21.97z"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div className="awareness-module-off-ramp">
      <div className="row">
        <div className="col-sm-9 col-xs-12">
          <div className="awareness-module-off-ramp-content-head">
            WHAT'S NEW
          </div>
          <div className="awareness-module-off-ramp-content">
            <div className="awareness-module-content-item awareness-module-with-bullet">
              Mobile&ndash;friendly
            </div>
            <div className="awareness-module-content-item awareness-module-with-bullet">
              Faster from start to finish
            </div>
            <div className="awareness-module-content-item">
              Go paperless for convenience
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-xs-12">
          <Button
            id="awareness-module-close-link"
            buttonType="primary-large"
            className="btn-trp-primary-large"
            onClick={handleAwarenessModule}
          >
            Get Started
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default AwarenessModule;
